import { apiGet, apiPatch, apiPost } from '../_common';

export default {
  create(request) {
    return apiPost('/magenta/promotions/benefit', request)
    .then(result => result.response);
  },
  update(rewardId, request) {
    return apiPatch(`/magenta/promotions/benefit/${rewardId}`, request)
    .then(result => result.response);
  },
  find(rewardId) {
    return apiGet(`/magenta/promotions/benefit/${rewardId}`)
      .then(result => result.response);
  },
  search(query) {
    return apiGet('/magenta/promotions/benefit', query)
      .then(result => result.response);
  }
};
